import CEUtils from '@cekit/ce-utils';
import settings from 'settings';
const { rootComponent, nodeComponent, affixs, hides, title } = settings;
// const views = import.meta.glob('../views/**/*.vue', { eager: true });

/**
 * @description 设置标题
 * @param pageTitle
 * @returns {string}
 */
export default function getPageTitle(pageTitle) {
    if (pageTitle) {
        return `${pageTitle}-${title}`;
    }
    return `${title}`;
}

/**
 * @description intelligence模式根据permissions数组拦截路由
 * @param routes
 * @param permissions
 * @returns {[]}
 */
export function filterPermissionsRoutes(routes, permissions) {
    // item.meta.permissions为空，或item.meta.permissions里面有数组的权限
    // .filter(item => permissions.some(auth => item.name === auth))
    return routes
        .filter(item => {
            if (typeof permissions === 'string' && permissions === 'all') return true;
            else return permissions.includes(item.name);
        })
        .map(item => {
            item['title'] = item.meta.title;
            item = Object.assign({}, item);
            if (item.children) item.children = filterPermissionsRoutes(item.children, permissions);
            return item;
        });
}

/**
 * @description 导出过滤后的菜单
 * @param routes
 * @returns {[]}
 */
export function filterNotHiddenRoutes(routes) {
    return routes
        .filter(item => !item.meta.isHide)
        .map(item => {
            item['title'] = item.meta.title;
            item = Object.assign({}, item);
            if (item.children) item.children = filterNotHiddenRoutes(item.children);
            return item;
        });
}

// 递归过滤 `isAffix: true` 的数组
export function filterNotAffixRoutes(routes) {
    return routes
        .filter(item => item.meta.isAffix)
        .map(item => {
            item['title'] = item.meta.title;
            item = Object.assign({}, item);
            if (item.children) item.children = filterNotAffixRoutes(item.children);
            return item;
        });
}

// 数据格式(getMenuListByTenantId.js)=>router
export function formatMenuData(Menus, Auths) {
    /**
     * v1 菜单版本
     * path: "/home",                 // => pageUrl
     * redirect: "/home",             // => 获得子菜单childMenuList的第一个path
     * component: "ce-demo/home",     // => 通过path字典赋值使用的component (根目录使用：layouts/default/index | 父目录：layouts/default/parent ｜ 子项：'/user/user-list')
     * meta: {
     *     parent: "/home",           // => 父节点路径，如果父路径为/ 则为本身的path /home 本例子
     *     icon: "el-icon-s-order",   // => menuIcon
     *     title: "文档",              // => menuName
     *     isAffix: true,             // => 通过 settings 配置固定的菜单
     *   + path: '',                  // => 如果islink isIframe isApp的通过 links,iframese,apps的键取值，优先高->底 isApp>isframe>islink
     *   M isLink: '',=>isLink:false, // => 改为Boolean 通过 settings 配置地址是否为link，是则将配置的键值links: {'/docs': '//baidu.com', '/user': '//element.eleme.cn'}
     *     isHide: false,             // => 通过 settings 配置是否显示在菜单
     *     isIframe: false,           // => 通过 settings 配置地址是否为isIframe, 是则将配置的键值iframes: {'/docs': '//baidu.com', '/user': '//element.eleme.cn'}
     *   + isApp: false,              // => 追加属性，通过 settings 配置地址是否为子应用，是则将配置的键值apps: {'/docs': '//10.12.68.22/app/docs', '/user': '//10.12.68.22/app/user'}
     *   D permissions:[],            // => 废弃 通过 menuCode 检索
     * },
     * children: [],                  // => childMenuList
     * -----------------------------------------------------------------------------
     * - tenantId: 租户ID
     * + menuId: 同步原菜单ID
     * + parentId: 父菜单ID
     * - menuCode: 菜单CODE   根据此属性，筛选角色需要的菜单
     * + menuName: 菜单名称
     * + menuIcon: 菜单图标
     * + sortNum: 菜单顺序
     * - menuState: 菜单显示状态  0-不显示  1-显示， 不用根据此条件筛选数据，状态码由后台控制，2021年5月12日张富强
     * - applicationCode: 应用code
     * - applicationPageId: 页面id
     * + pageUrl: 页面链接
     * - createTime: 创建事件
     * - updateTime: 更新事件
     * - createUser: 创建人
     * - updateUser: 更新人
     * - childMenuList: 子菜单列表数组
     */
    // Menu树转换为数组[]结构，去掉childMenuList的子项数据 api参考: http://10.12.68.61:8070/#/
    const menusArray = CEUtils.toTreeArray(Menus, { children: 'childMenuList', clear: false });
    // menusArray过滤权限Auths的数据，并循环格式化menu的数据为routes可以加载的对象
    // .filter(menu => menu.pageUrl && Auths.some(auth => menu.menuCode === auth))
    // 判断是否不过滤权限
    const menuAuth = menusArray
        .filter(menu => {
            if (typeof Auths === 'string' && Auths === 'all') return true;
            else return menu.pageUrl && Auths && Auths.includes(menu.menuCode);
        })
        .map(menu => {
            // 获取父节点数据项, parent: parentChild.pageUrl
            const parentChild = CEUtils.find(menusArray, item => item.menuId === menu.parentId);
            // 获得该节点是否有子节点，返回数量作为判断依据。
            const isChildren = CEUtils.findKey(menusArray, item => item.parentId === menu.menuId);
            // 查找匹配第一条数据
            const childrenFirst = CEUtils.find(menusArray, item => item.parentId === menu.menuId);
            // pageUrl字符串截取?号前的字符串
            const urlAndParams = menu.pageUrl.split('?');
            const pageUrl = menu.pageUrl.indexOf('?') !== -1 ? urlAndParams[0] : menu.pageUrl;
            const params = urlAndParams.length > 1 && CEUtils.unserialize(urlAndParams[1]);

            const appPath = parentChild ? '/' + parentChild.pageUrl + '/' + menu.menuCode : menu.path;
            // const appPath = pageUrl.replace(/[@,#,$,%,^,?,&,*,-,//,/,.,:,.html,-]/g, '');
            /**
             * name: 根据pageUrl值格式化 /user/user-list => user-user-list
             * component: 根目录使用 rootComponent 目录使用 nodeComponent 节点使用 pageUrl 其它(apps,iframes,links)使用: nodeComponent
             * meta.parent: 同parentPath
             * meta.isAffix: 使用setting.affixs配置查找对应设置
             * meta.isHide: 使用setting.hides配置查找对应设置
             */
            let _menu = {
                path: ['link', 'iframe', 'app'].includes(menu.externalLink) ? appPath : pageUrl,
                name: pageUrl === '/ce-demo' ? 'center' : pageUrl ? pageUrl.substr(1).replace(/\//g, '-') : '',
                component: pageUrl === '/ce-demo' || isChildren || ['link', 'iframe', 'app'].includes(menu.externalLink) ? nodeComponent : pageUrl.substr(1) + '/index',
                sort: menu.sortNum,
                id: menu.menuId,
                parentId: menu.parentId,
                meta: {
                    parent: ['link', 'iframe', 'app'].includes(menu.externalLink) ? appPath : parentChild ? parentChild.pageUrl : pageUrl,
                    icon: menu.menuIcon,
                    title: menu.menuName,
                    // path: (apps[menu.menuCode] && apps[menu.menuCode].path) || iframes[menu.menuCode] || links[menu.menuCode] || '',
                    // isApp: apps[menu.menuCode] ? true : false,
                    // isIframe: iframes[menu.menuCode] && !apps[menu.menuCode] ? true : false,
                    // isLink: links[menu.menuCode] && !apps[menu.menuCode] && !iframes[menu.menuCode] ? true : false,
                    path: ['link', 'iframe', 'app'].includes(menu.externalLink) && menu.pageUrl,
                    isApp: menu.externalLink === 'app' ? true : false,
                    isIframe: menu.externalLink === 'iframe' ? true : false,
                    isLink: menu.externalLink === 'link' ? true : false,
                    isAffix: affixs && affixs.includes(menu.menuCode),
                    isHide: hides && hides.includes(menu.menuCode),
                    params: params || {},
                    helpLink: menu.helpLink || '',
                },
            };
            // 赋值菜单中的第一项连接地址
            if (menu.pageUrl === '/ce-demo') {
                _menu['redirect'] = '/ce-demo/home';
            } else if (isChildren) {
                _menu['redirect'] = childrenFirst.pageUrl.indexOf('?') !== -1 ? childrenFirst.pageUrl.split('?')[0] : childrenFirst.pageUrl;
            }
            menu = Object.assign({}, _menu);
            return menu;
        });
    // menuAuth数组对象转变为Tree型菜单 api参考: http://10.12.68.61:8070/#/
    const menusTree = CEUtils.toArrayTree(menuAuth, {
        key: 'id',
        parentKey: 'parentId',
        sortKey: 'sort',
    });
    if (!menusTree) return [];
    return [
        {
            path: '/',
            name: 'root',
            component: rootComponent,
            children: [
                // {
                //     path: '/home',
                //     name: 'home',
                //     component: 'home/index',
                //     meta: {
                //         title: '概览',
                //         parent: '/home',
                //         icon: 'el-icon-s-home',
                //         path: '',
                //         isApp: false,
                //         isIframe: false,
                //         isLink: false,
                //         isAffix: true,
                //         isHide: false,
                //         params: {},
                //     },
                // },
                ...menusTree,
            ],
        },
    ];
}
